import React, { Component } from "react";
import ReactTable from "react-table";
import { PropTypes } from "prop-types";
import { Container, Row, Col } from "reactstrap";
import { ReactTableDefaults } from "react-table";
import HeaderResultado from "./HeaderResultado";
import HttpUtil from "../../Util/httpUtil";
import "../../_Content/css/resultado.css";
import Config from "../../Util/config";

class ErrosEstrutura extends Component {
  constructor(props) {
    super(props);

    this.state = {
      moduloEfd: this.props.params.moduloEfd,
      idArquivo: this.props.params.idArquivo,
      data: [],
      pages: null,
      totalSize: null,
      loading: true,
      totalSizeLoaded: 0,
      rawData: [],
      columns: [
        {
          Header: "Linha",
          accessor: "LINHA",
          maxWidth: 100,
          className: "text-center",
          resizable: false
        },
        {
          Header: "Registro",
          accessor: "REGISTRO",
          maxWidth: 100,
          className: "text-center",
          resizable: false
        },
        {
          Header: "Campo",
          accessor: "CAMPO",
          maxWidth: 200,
          className: "text-center",
          resizable: false
        },
        {
          Header: "Valor encontrado",
          accessor: "VALOR_INFORMADO",
          maxWidth: 200,
          className: "text-center",
          resizable: false
        },
        {
          Header: "Orientação",
          accessor: "MENSAGEM",
          className: "text-left",
          resizable: false,
          Cell: row => <div dangerouslySetInnerHTML={{ __html: row.value ? row.value : "" }} />
        }
      ]
    };

    this.fetchData(this.state);
  }

  requestData = (idArquivo, moduloEfd, totalSize, sorted, filtered) => {
    return new Promise((resolve, reject) => {

      let urlApi = (moduloEfd === 'Fiscal' || moduloEfd === 'SimplesNacional') ? Config.urls.API_URL_FISCAL
      : moduloEfd == 'ECF' ? Config.urls.API_URL_ECF
      : moduloEfd == 'ECD' ? Config.urls.API_URL_ECD
      : Config.urls.API_URL_CONT;

      var request = `${urlApi}Validacao/ExibirErrosEstrutura/${
        this.state.idArquivo
        }`;
      HttpUtil.eco_GET(
        request,
        response => {
          this.state.rawData = response.data;

          const res = {
            rows: this.state.rawData,
            totalSize: totalSize
          };

          resolve(res);
        },
        reject => {
          console.log(reject);
        }
      );
    });
  };

  requestTotal = (idArquivo, moduloEfd) => {

    let urlApi =
      (moduloEfd === 'Fiscal' || moduloEfd === 'SimplesNacional') ? Config.urls.API_URL_FISCAL
      : moduloEfd == 'ECF' ? Config.urls.API_URL_ECF
      : moduloEfd == 'ECD' ? Config.urls.API_URL_ECD
      : Config.urls.API_URL_CONT;

    var urlApiTotal = `${urlApi}Validacao/ExibirTotalErrosEstrutura/${idArquivo}`;
    return new Promise((resolve, reject) => {
      HttpUtil.eco_GET(
        urlApiTotal,
        response => {
          const res = {
            totalSize: response.data
          };

          totalSizeLoaded: response.data;

          resolve(res);
        },
        reject => {
          console.log(reject);
        }
      );
    });
  };

  fetchData(state) {
    this.setState({ loading: true });

    if (this.state.totalSizeLoaded > 0) {
      this.requestData(
        this.state.idArquivo,
        this.state.moduloEfd,
        this.state.totalSizeLoaded,
        state.sorted,
        state.filtered
      ).then(res => {
        this.setState({
          data: res.rows,
          totalSize: res.totalSize,
          loading: false
        });
      });
    } else {
      this.requestTotal(this.state.idArquivo, this.state.moduloEfd).then(
        res => {
          this.requestData(
            this.state.idArquivo,
            this.state.moduloEfd,
            res.totalSize,
            state.sorted,
            state.filtered
          ).then(res => {
            this.setState({
              data: res.rows,
              totalSize: res.totalSize,
              loading: false
            });
          });
        }
      );
    }
  }

  render() {
    const { idArquivo, moduloEfd, data, loading, totalSize } = this.state;

    return (
      <div>
        <Container>
          <Row>
            <Col>
              <HeaderResultado
                moduloEfd={this.state.moduloEfd}
                filtro={false}
                idArquivo={this.state.idArquivo}
                totalReg={totalSize}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <ReactTable
                noDataText="Nenhum resultado encontrado"
                columns={this.state.columns}
                className="eco-react-table errosEstrutura"
                data={this.state.data}
                loading={loading}
                showPagination={false}
                pageSize={this.state.data.length}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ErrosEstrutura;



// WEBPACK FOOTER //
// ./src/Componente/Resultado/ErrosEstrutura.jsx